import React, { useMemo } from "react";
import PowerBi from "@pages/PowerBi";
import PageHeader from "@features/shared/components/PageHeader";

/**
 * KeyDealerPerformance Component
 * Displays Key Dealer Performance Power BI dashboard
 * Optimized with React.memo and useMemo
 */
const KeyDealerPerformance = () => {
  // Memoized page configuration
  const pageName = useMemo(
    () => ({
      id: "b8ed9801a66e9699a458",
      name: "KD/LCD Performance",
    }),
    []
  );

  return (
    <>
      <PageHeader title="KD/LCD Performance" path="/" />
      <div className="p-2">
        <PowerBi
          id="e0eb2599-b39d-4b21-919e-4c5a1bd8ed69"
          pageName={pageName}
          filterName="SH2Master"
          height="80vh"
        />
      </div>
    </>
  );
};

export default React.memo(KeyDealerPerformance);